import { render } from "./Separator.vue?vue&type=template&id=aa4062da"
import script from "./Separator.vue?vue&type=script&lang=ts"
export * from "./Separator.vue?vue&type=script&lang=ts"
script.render = render

export default script